<template>
  <div class="page-wrapper">
    <VotingManagement @tab="switchTab" v-if="tab_switch == 'management' && $checkPermission('voting')"></VotingManagement>
    <NominationsManagement @tab="switchTab" v-if="tab_switch == 'nominations' && $checkPermission('voting')"></NominationsManagement>
    <VotingReport @tab="switchTab" v-if="tab_switch == 'voting_report' && $checkPermission('voting')"></VotingReport>
    <VotingTopup @tab="switchTab" v-if="tab_switch == 'voting_topup' && $checkPermission('voting')"></VotingTopup>
  </div>
</template>
<script>
import VotingManagement from "./VotingManagement.vue";
import NominationsManagement from "./NominationsManagement.vue";
import VotingReport from "./VotingReport.vue";
import VotingTopup from "./VotingTopup.vue"
export default {
  components: {
    VotingManagement,
    NominationsManagement,
    VotingReport,
    VotingTopup
  },
  data: () => ({
    tab_switch: "management",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "management";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    } else {
      vm.tab_switch = "management";
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "s_voting", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

